import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { audienceFor, audienceNotFor } from '../data/landing';
export function AudienceSection() {
  return <section className="w-full bg-white py-20 lg:py-24" data-id="element-17" data-mp="n3kvgv6fuo8v">
      <div className="mx-auto max-w-content px-6" data-id="element-18" data-mp="s1mi1q32p5p3">
        <h2 className="mx-auto max-w-2xl text-center font-display text-3xl font-bold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-19" data-mp="wznz65gxuuxx">
          Buscamos profes que quieran elevar la vara.
        </h2>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-8" data-id="element-20" data-mp="4b0as10w7pg5">
          <div className="flex flex-col rounded-3xl bg-nature-soft/60 p-7 sm:p-9" data-id="element-21" data-mp="48xmpmjaw6e2">
            <h3 className="font-display text-sm font-bold uppercase tracking-[0.14em] text-nature-dark" data-id="element-22" data-mp="98saviboyhvf">
              Es para vos si...
            </h3>
            <ul className="mt-6 space-y-4" data-id="element-23" data-mp="3crbvpzs1ilg7">
              {audienceFor.map(item => <li key={item} className="flex gap-3" data-id="element-24" data-mp="3hpn19ybay9sm">
                  <CheckIcon className="mt-1 h-5 w-5 shrink-0 text-nature-dark" strokeWidth={2.5} aria-hidden="true" data-id="element-25" data-mp="3ho2belzxnf13" />
                  <span className="text-base leading-relaxed text-ink sm:text-lg" data-id="element-26" data-mp="zchnyg60orok">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col rounded-3xl bg-cream p-7 sm:p-9" data-id="element-27" data-mp="qj5rdy8nodaa">
            <h3 className="font-display text-sm font-bold uppercase tracking-[0.14em] text-ink-muted" data-id="element-28" data-mp="ll48bdb8cdyt">
              No es para vos si...
            </h3>
            <ul className="mt-6 space-y-4" data-id="element-29" data-mp="bm54q95bn8io">
              {audienceNotFor.map(item => <li key={item} className="flex gap-3" data-id="element-30" data-mp="7kjoqexhqe49">
                  <XIcon className="mt-1 h-5 w-5 shrink-0 text-ink-muted" strokeWidth={2.5} aria-hidden="true" data-id="element-31" data-mp="7m4ii2bzdt12" />
                  <span className="text-base leading-relaxed text-ink-soft sm:text-lg" data-id="element-32" data-mp="21zw1vtk43r9p">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}